import Vue from 'vue'
import Vuex from 'vuex'
import {mutations} from './mutations'
import * as actions from './actions'
import {getters} from "./getters";
import {getLocalUser} from "../../assets/js/helpers/auth";

Vue.use(Vuex);

const user = getLocalUser();

const state = {
    currentUser: user,
    isLoggedIn: !!user,
    loading: false,
    auth_error: null,
    customers: [],
    authToken: localStorage.getItem('token'),
    laptops: []
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
})